"use client";

import { Card, Button, message } from "antd";
import { CopyOutlined, DownloadOutlined, MobileOutlined } from "@ant-design/icons";
import { useTitleDataStore } from "@/core/stores/title-data.store";
import { useEffect } from "react";

// Thu thập app từ env (hiện tại 1 app, sau có thể thêm _2, _3...)
function getDownloadApps(): { url: string; label: string }[] {
  const apps: { url: string; label: string }[] = [];
  const url = process.env.REACT_APP_APP_DOWNLOAD_APK;
  const label = process.env.REACT_APP_APP_DOWNLOAD_APK_LABEL || "Ứng dụng";
  if (url) apps.push({ url, label });
  // Mở rộng sau: REACT_APP_APP_DOWNLOAD_APK_2, REACT_APP_APP_DOWNLOAD_APK_LABEL_2
  return apps;
}

const DOWNLOAD_APPS = getDownloadApps();

export default function AdminAppsPage() {
  const titleData = useTitleDataStore();
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    titleData.setTitleActions({}, 0);
  }, [titleData]);

  const copyDownloadLink = (url: string) => {
    const fullUrl = url.startsWith("http") ? url : `${window.location.origin}${url.startsWith("/") ? "" : "/"}${url}`;
    navigator.clipboard.writeText(fullUrl).then(
      () => messageApi.success("Đã copy link"),
      () => messageApi.error("Không copy được")
    );
  };

  return (
    <div className="p-4">
      {contextHolder}
      <p className="text-gray-600 mb-4">
        Các ứng dụng (bản cài đặt) dùng cho nhà máy. Tải về và cài trên thiết bị khi cần.
      </p>
      <div className="flex flex-wrap gap-4">
        {DOWNLOAD_APPS.length === 0 ? (
          <Card className="flex-1 min-w-[280px]">
            <div className="text-gray-500 text-center py-4">
              Chưa cấu hình ứng dụng nào. Thêm biến REACT_APP_APP_DOWNLOAD_APK trong config nhà máy để hiển thị link tải.
            </div>
          </Card>
        ) : (
          DOWNLOAD_APPS.map((app, index) => (
            <Card
              key={index}
              className="flex-1 min-w-[280px] max-w-[360px]"
              styles={{ body: { padding: 20 } }}
            >
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 rounded-lg bg-gray-100 flex items-center justify-center shrink-0">
                  <MobileOutlined className="text-2xl text-gray-500" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-base m-0 mb-1">{app.label}</h3>
                  <p className="text-gray-500 text-sm m-0 mb-3">File cài đặt Android (APK)</p>
                  <div className="flex flex-wrap gap-2">
                    <a href={app.url} download>
                      <Button type="primary" icon={<DownloadOutlined />}>
                        Tải về
                      </Button>
                    </a>
                    <Button
                      icon={<CopyOutlined />}
                      onClick={() => copyDownloadLink(app.url)}
                    >
                      Copy link
                    </Button>
                  </div>
                </div>
              </div>
            </Card>
          ))
        )}
      </div>
    </div>
  );
}
